export const ICONS: { [key in InfoBlockType]: string } = {
  info: 'kbase kbase-info-alt',
  warning: 'kbase kbase-warning-alt',
  danger: 'kbase kbase-close-circle-alt',
  help: 'kbase kbase-question-alt',
  success: 'kbase kbase-check-circle-alt',
}

export enum InfoBlockType {
  Danger = 'danger',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
  Help = 'help',
}

export enum InfoBlockSize {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
}

export enum InfoBlockRounded {
  None = 'none',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}
